import type { HTMLAttributes, ReactNode } from 'react';

interface Props extends HTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  count?: number | string;
  icon?: ReactNode;
  children: ReactNode;
}

export function Chip({ active, count, icon, children, className = '', ...rest }: Props) {
  return (
    <button
      className={[
        'inline-flex items-center gap-2 px-3 h-9 rounded-pill text-sm transition border',
        active
          ? 'bg-accent text-text-inverse border-accent'
          : 'bg-white/80 text-text border-text/10 hover:bg-surface',
        className,
      ].join(' ')}
      {...rest}
    >
      {icon}
      <span>{children}</span>
      {count != null && <span className="opacity-70 text-xs">{count}</span>}
    </button>
  );
}
